import React from "react";
import PropTypes from "prop-types";
import { AiFillCaretRight } from "react-icons/ai";
import "../common.css";

const TextInput = ({
  page,
  label,
  icon,
  name,
  type,
  placeholder,
  value,
  onChange,
  onBlur,
  disabled,
  maxLength,
  min,
  max,
  error,
  inputlabelcolor,
  inputiconcolor,
  inputErrorcolor,
}) => {
  return (
    <div className="mt-4">
      <div
        className={`${
          page == "design3" || page == "design6" || page == "design5"
            ? "custom-input-title2"
            : page == "design9"
            ? "custom-input-title3"
            : "custom-input-title"
        }`}
        style={{ color: inputlabelcolor }}
      >
        {label}
      </div>
      <div style={{ position: "relative" }}>
        <span
          className={`${
            page == "design3" || page == "design6" || page == "design5"
              ? "icon-style2"
              : page == "design9"
              ? "icon-style3"
              : "icon-style"
          }`}
        >
          {icon ? (
            icon
          ) : (
            <>
              <AiFillCaretRight color={inputiconcolor} />
            </>
          )}
        </span>
        <input
          name={name}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          className={`${
            page == "design3" || page == "design6" || page == "design5"
              ? "custom-form-control2"
              : page == "design9"
              ? "custom-form-control3"
              : "custom-form-control"
          }`}
          disabled={disabled}
          maxLength={maxLength}
          min={min}
          max={max}
          style={{ textIndent: 20 }}
        />
      </div>
      {error && (
        <div style={{ color: inputErrorcolor, fontSize: 10 }}>{error}</div>
      )}
    </div>
  );
};

TextInput.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  name: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  maxLength: PropTypes.string,
  min: PropTypes.string,
  max: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

TextInput.defaultProps = {
  label: "text",
  icon: "",
  name: "",
  type: "",
  placeholder: "",
  value: "",
  onChange: undefined,
  onBlur: undefined,
  disabled: false,
  maxLength: undefined,
  min: undefined,
  max: undefined,
  error: "",
};

export default TextInput;
